import fetch from 'isomorphic-fetch'

class SectionSponsorsApi {
  static requestHeaders() {
    return {
      'Content-Type': 'application/json'
    }
  }

  static getAll(sectionId) {
    const headers = this.requestHeaders()

    return fetch(`${process.env.REACT_APP_API_HOST}/sections/${sectionId}/sponsors`, {
      method: 'GET',
      headers: headers
    })
      .then(response => response.json().then(json => ({ json, response })))
      .catch(error => {
        return error
      })
  }
}

export default SectionSponsorsApi
